<!--
 * A Vue component for exporting an array to CSV.
 *
 * Properties
 * ==========
 * - dataArray -
 * (Reuired) An array with data to be exported
 *
 * - fileName -
 * (Optional) Name of the file. Default is 'export.csv'.
 *
 * - fieldSeparator -
 * (Optional) Sets the fieldseprator. Default is ';'.
 *
 * - disabled -
 * (Optional) When the button must ne disabeld.
 *
-->
<template>
    <div>
        <b-button
            v-bind="$attrs"
            variant="outline-dark"
            class="btn btn-default btn-glyphicon"
            @click="$_csvExport"
            :disabled="disabled"
        >
            <span class="fas fa-download"></span>
        </b-button>
    </div>
</template>

<script>
    import { arrayNotEmpty } from '../services/utilities';
    export default {
        inheritAttrs: false,
        name: 'CsvExport',
        props: {
            dataArray: { type: Array, required: true },
            fileName: { type: String, required: false, default: 'export.csv' },
            fieldSeparator: { type: String, required: false, default: ';' },
            disabled: { type: Boolean, required: false }
        },
        methods: {
            $_csvExport() {
                const dataToExport = {
                    dataArray: this.dataArray,
                    fileName: this.fileName,
                    fieldSeparator: this.fieldSeparator
                };
                if (
                    dataToExport &&
                    dataToExport.dataArray &&
                    arrayNotEmpty(dataToExport.dataArray)
                ) {
                    const fieldSeparator = dataToExport.fieldSeparator
                        ? dataToExport.fieldSeparator
                        : ';';
                    const fileName = dataToExport.fileName
                        ? `${dataToExport.fileName}`
                        : 'export.csv';

                    let csvContent = 'data:text/csv;charset=utf-8,';

                    csvContent += [
                        Object.keys(dataToExport.dataArray[0]).join(fieldSeparator),
                        ...dataToExport.dataArray.map((item) =>
                            Object.values(item).join(fieldSeparator)
                        )
                    ]
                        .join('\n')
                        .replace(/(^\[)|(\]$)/gm, '');

                    const data = encodeURI(csvContent);
                    const link = document.createElement('a');

                    link.setAttribute('href', data);
                    link.setAttribute('download', fileName);
                    link.click();
                } else {
                    console.error('[CsvExport warn]: ' + 'No data to export!');
                }
            }
        }
    };
</script>
